import storage from "@roman/shared/lib/localStorage";
import { addWeeks, differenceInMilliseconds, startOfDay } from "date-fns";

const ONE_WEEK_MS = differenceInMilliseconds(addWeeks(startOfDay(new Date()), 1), startOfDay(new Date()));

export const isLoginRecent = (deadline_ms = ONE_WEEK_MS, loginAt?: Date | null): boolean => {
  const storedLoginAt = loginAt ?? storage.getLoginAt();
  if (storedLoginAt === null) return false;
  try {
    const loginTime = storedLoginAt.getTime();
    return Date.now() - loginTime < deadline_ms;
  } catch {
    return false;
  }
};
